export default __webpack_public_path__ + "assets/1d4132f13018ef17ab8a1952f7604848.png";